export class Floater {
  constructor(data = {}, initialHostId) {
    const {
      id,
      link_id,
      x = 0.5,
      y = 0.5,
      rotation,
      hostId = initialHostId,
    } = data;

    Object.assign(this, {
      id,
      link_id,
      x,
      y,
      rotation,
      hostId,
    });
  }

  convertImageCoordsToSphericalAngles() {
    return [(this.x - 0.5) * 360, (this.y - 0.5) * 180];
  }

  /**
   * Returns Marzipano-friendly radiant coords
   * @param {[number, number]} angles
   * @returns {{yaw: number, pitch: number}}
   */
  convertSphericalAnglesToRadiants(
    angles = this.convertImageCoordsToSphericalAngles(),
  ) {
    const [yaw, pitch] = angles.map((angle) => (angle * Math.PI) / 180);

    return { yaw, pitch };
  }
}
